import React, { forwardRef } from 'react';
import FormField from './FormField';

function buildTextareaClassName({ error, className = '' }) {
    return ['textarea', error ? 'input-error' : '', className].filter(Boolean).join(' ');
}

const TextareaInput = forwardRef(function TextareaInput(
    {
        label,
        name,
        id,
        error,
        helper,
        note,
        required = false,
        className = '',
        fieldClassName = '',
        rows = 4,
        ...props
    },
    ref,
) {
    const textareaId = id || (name ? `textarea-${name}` : undefined);
    const textarea = (
        <textarea
            ref={ref}
            id={textareaId}
            name={name}
            rows={rows}
            required={required}
            className={buildTextareaClassName({ error, className })}
            {...props}
        />
    );

    if (!label && !error && !helper && !note) {
        return textarea;
    }

    return (
        <FormField
            label={label}
            htmlFor={textareaId}
            required={required}
            error={error}
            helper={helper}
            note={note}
            className={fieldClassName}
        >
            {textarea}
        </FormField>
    );
});

export default TextareaInput;
